<script setup lang="ts">
import {
  PhxPicture as PhxCorePicture,
  type PhxPictureProps as PhxCorePictureProps,
} from '@sg-core/src/View/Components/Atoms/Picture';

withDefaults(defineProps<PhxCorePictureProps>(), {
  fade: undefined,
});
</script>

<template>
  <PhxCorePicture v-bind="$props" />
</template>
